import styled from 'styled-components';

export const AuthEditContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  flex: 2;
  padding: 1rem;
  margin-top: 2rem;
  background: #262f3b;
  width: 100%;
  border-radius: 0.5rem;

  & > form {
    width: 100%;
  }
`;

export const AuthEditHeaderContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 1rem;
  width: 100%;

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 2.5rem;

    & > span {
      margin-right: 0.5rem;
      font-size: 1.2rem;
    }
  }

  & > div.auth-name-input-box {
    flex: 2;
    & > input {
      height: 2.5rem;
    }
  }
  & > div.auth-level-input-box {
    flex: 2;
    & > select {
      height: 2.5rem;
    }
  }
  & > div.auth-memo-input-box {
    flex: 6;
    & > input {
      width: 50rem;
      height: 2.5rem;
    }
  }
  & > div.auth-submit-input-box {
    flex: 2;

    & > button {
      margin: 0 0.5rem;
    }
  }
`;

export const AuthEditContentContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 1rem;
  width: 100%;
  flex: 4;

  & > div.factory-auth-check-box {
    flex: 1;

    & > select {
      width: 30rem;
    }
  }
`;
